<template>
    <div class="audit_edit_pf pl10 mt20">

        <!--入驻进展区域-->
        <div class="mt20 mb20" v-if="control.schedule">
            <el-row>
                <el-col :span="2">
                    <div class="grid-content">审核进展：</div>
                </el-col>
                <el-col :span="22"><div class="grid-content"><span class="main_word">{{ control.schedule }}</span></div></el-col>
            </el-row>
            <el-row>
                <el-col :span="22" :offset="2"><div class="grid-content" v-if="control.content">
                    ({{control.content}})</div></el-col>
            </el-row>
        </div>

        <span class="dib">税务信息</span><span class="line"></span>
        <!--视图查看区域-->
        <div class="mt20" v-show="control.view == 0">
            <el-form label-width="207px" class="demo-ruleForm">

                <!-- 纳税人识别号 -->
                <el-form-item label="纳税人识别号：">
                    <span>{{ financeData.taxpayerRegistrationCode }}</span>
                    <span class="main_word" v-if="control.compare == 1 && oldFinanceData.taxpayerRegistrationCode ">&nbsp;&nbsp; {{ oldFinanceData.taxpayerRegistrationCode }}</span>
                </el-form-item>

                <!-- 纳税人类型 -->
                <el-form-item label="纳税人类型：" class="mt20">

                    <span v-if="financeData.taxpayerType == 1">一般纳税人</span>
                    <span v-if="financeData.taxpayerType == 2">小规模纳税人</span>

                    <span class="main_word" v-if="oldFinanceData.taxpayerType == 1 && control.compare == 1">&nbsp;&nbsp; 一般纳税人</span>
                    <span class="main_word" v-if="oldFinanceData.taxpayerType == 2 && control.compare == 1">&nbsp;&nbsp; 小规模纳税人</span>

                </el-form-item>

                <el-form-item v-if="financeData.taxpayerType == 1" label="一般纳税人资格认定表：">
                    <div>
                        <template v-if="financeData.generalTaxpayerFile">
                            <img @click="previewPic($event)" v-for="gtFile in financeData.generalTaxpayerFile.split(',')" class="pic_skan" :src="gtFile">

                            <template v-if="oldFinanceData.generalTaxpayerFile">
                                <img @click="previewPic($event)" class="pic_skan_red" v-for="sgtFile in oldFinanceData.generalTaxpayerFile.split(',')"
                                      :src="sgtFile"  v-if="control.compare == 1">
                            </template>

                        </template>
                    </div>
                </el-form-item>
                <span class="dib">货款支付账户</span><span class="second_line"></span>
                <!-- 银行开户名 -->
                <el-table :data="financeData.accounts" border
                          style="width: 80%;margin: 0 auto;margin-bottom:22px;margin-top: 22px">
                    <el-table-column label="银行开户名" min-width="200" align="center" prop="accountName">
                    </el-table-column>
                    <el-table-column prop="accountNumber" label="银行帐号" min-width="200" align="center">
                    </el-table-column>
                    <el-table-column prop="bankName" label="银行名称" min-width="200" align="center">
                    </el-table-column>
                    <el-table-column v-if="financeData.registeredCountry != 1" prop="swiftCode" label="SwiftCode" min-width="200" align="center">
                    </el-table-column>
                    <el-table-column v-if="financeData.registeredCountry == 1" prop="province" label="省" min-width="200" align="center">
                    </el-table-column>
                    <el-table-column v-if="financeData.registeredCountry == 1" prop="city" label="市" min-width="200" align="center">
                    </el-table-column>
                </el-table>

                <el-table :data="oldFinanceData.accounts" border
                          style="width: 80%;margin: 0 auto;margin-bottom:22px;margin-top: 22px;border: 2px solid #ff4a7d;"
                          v-if="control.compare == 1 && financeData.accounts.length!=oldFinanceData.accounts.length">
                    <el-table-column label="银行开户名" min-width="200" align="center" prop="accountName">
                    </el-table-column>
                    <el-table-column prop="accountNumber" label="银行帐号" min-width="200" align="center">
                    </el-table-column>
                    <el-table-column prop="bankName" label="银行名称" min-width="200" align="center">
                    </el-table-column>
                    <el-table-column v-if="financeData.registeredCountry != 1" prop="swiftCode" label="SwiftCode" min-width="200" align="center">
                    </el-table-column>
                    <el-table-column v-if="financeData.registeredCountry == 1" prop="province" label="省" min-width="200" align="center">
                    </el-table-column>
                    <el-table-column v-if="financeData.registeredCountry == 1" prop="city" label="市" min-width="200" align="center">
                    </el-table-column>
                </el-table>
                <!-- 操作 -->
                <el-form-item class="mt50 mb50" style="margin-left: 300px">
                    <el-button type="primary" class="mr10" @click="returnPage">返回</el-button>
                    <el-button type="primary" class="mr10" @click="auditRecord(0)" v-if="control.audit == 1">审核通过</el-button>
                    <el-button type="primary" class="mr10" @click="auditRecord(1)" v-if="control.audit == 1">审核驳回</el-button>
                </el-form-item>
            </el-form>
        </div>

        <!--编辑区域-->
        <div class="mt20" v-show="control.view == 1">
            <el-form :model="financeData" :rules="rules" ref="financeData" label-width="207px" class="demo-ruleForm">

                <!-- 纳税人识别号 -->
                <el-form-item label="纳税人识别号：" prop="taxpayerRegistrationCode">
                    <el-input class="w500" v-model="financeData.taxpayerRegistrationCode" placeholder="请输入纳税人识别号"></el-input>
                </el-form-item>
                <!-- 纳税人类型 -->
                <el-form-item label="纳税人类型：" class="mt20" prop="taxpayerType">
                    <el-radio-group class="ml_10" v-model="financeData.taxpayerType" @change="typeChange">
                        <el-radio :label="1"><span class="f14 f666">一般纳税人</span></el-radio>
                        <el-radio :label="2"><span class="f14 f666">小规模纳税人</span></el-radio>
                    </el-radio-group>
                </el-form-item>
                <!-- 一般纳税人资格认定表 -->
                <el-form-item v-show="financeData.taxpayerType == 1" label="一般纳税人资格认定表：" class="mt20">
                    <span class="main_word rule_star178">*</span>
                    <span class="f666 f12 ml_10">复印件需加盖公司红章扫描上传</span>
                    <el-upload action="/suppliers/uploadImages?biz=0" :file-list="financeData.file"
                               list-type="picture-card" name="pic" :before-upload="beforeUpload" :on-preview="handlePictureCardPreview"
                               :on-success="handleUpload" :on-remove="handleRemoveGeneralTaxpayerFile">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <span class="f999 f12">上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M，可上传多张</span>
                    <p v-show="pic_1" class="pic_tip">请上传图片</p>
                </el-form-item>
                <span class="dib">货款支付账户</span><span class="second_line"></span>
                <el-form-item label-width="120px">
                    <el-button class="vtb" type="primary" @click="bankFormVisible = true">添加账户</el-button>
                </el-form-item>

                <el-table :data="financeData.accounts" border
                          style="width: 80%;margin: 0 auto;margin-bottom:22px;margin-top: 22px">
                    <el-table-column label="银行开户名" min-width="200" align="center" prop="accountName">
                    </el-table-column>
                    <el-table-column prop="accountNumber" label="银行帐号" min-width="200" align="center">
                    </el-table-column>
                    <el-table-column prop="bankName" label="银行名称" min-width="200" align="center">
                    </el-table-column>
                    <el-table-column v-if="financeData.registeredCountry != 1" prop="swiftCode" label="SwiftCode" min-width="200" align="center">
                    </el-table-column>
                    <el-table-column v-if="financeData.registeredCountry == 1" prop="province" label="省" min-width="200" align="center">
                    </el-table-column>
                    <el-table-column v-if="financeData.registeredCountry == 1" prop="city" label="市" min-width="200" align="center">
                    </el-table-column>
                    <el-table-column label="操作" min-width="200" align="center">
                        <template scope="scope">
                            <el-button :disabled="scope.row.id > 0" @click="removeDomain(scope.$index)" type="text" size="small">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <!-- 操作 -->
                <el-form-item class="mt50 mb50" style="margin-left: 300px">
                    <el-button type="primary" class="mr10" @click="returnPage">返回</el-button>
                    <el-button type="primary" class="mr10" @click="submitForm(0)">暂存</el-button>
                    <el-button type="primary" class="mr10" @click="submitForm(1)">{{control.status == 4 ? '重新提交' : '提交'}}</el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-dialog :visible.sync="dialogVisible" size="small">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>

        <el-dialog title="货款支付账户" :visible.sync="bankFormVisible" >
            <el-form :model="account" :rules="bankRules" ref="account"  class="demo-ruleForm" label-width="110px">
                <el-form-item label="银行开户名：" class="mt20" prop="accountName">
                    <el-input v-model="account.accountName" placeholder="请填写银行开户名" :maxlength="50"></el-input>
                </el-form-item>

                <el-form-item label="银行帐号：" class="mt20" prop="accountNumber">
                    <el-input  v-model="account.accountNumber" placeholder="请填写银行帐号" :maxlength="30"></el-input>
                </el-form-item>

                <el-form-item label="银行名称：" class="mt20" prop="bankName">
                    <el-input  v-model="account.bankName" placeholder="请填写银行名称" :maxlength="50"></el-input>
                </el-form-item>
                <el-form-item v-if="financeData.registeredCountry != 1" label="SwiftCode：" class="mt20">
                    <el-input v-model="account.swiftCode" placeholder="请填写SwiftCode" :maxlength="35"></el-input>
                    <span class="main_word rule_star100">*</span>
                </el-form-item>
                <el-form-item v-if="financeData.registeredCountry == 1" label="省：" class="mt20" prop="province">
                    <el-input  v-model="account.province" placeholder="请填写省" :maxlength="30"></el-input>
                </el-form-item>
                <el-form-item v-if="financeData.registeredCountry == 1" label="市：" class="mt20" prop="city">
                    <el-input  v-model="account.city" placeholder="请填写市" :maxlength="50"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="bankFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addDomain">确 定</el-button>
            </div>
        </el-dialog>


    </div>
</template>

<script type="text/javascript">
    export default {
        data () {
            return {
                bankFormVisible:false,
                control:{
                    loginType:0,
                    status:0,
                    view:0,
                    audit:0,
                    compare:0,
                    schedule:'',
                    content:''
                },
                // 图片预览
                dialogImageUrl: '',
                dialogVisible: false,

                isList: true,
                // 验证是否上传图片 提示
                pic_1: false,

                financeData:{
                    taxpayerRegistrationCode: '',
                    taxpayerType: 1,
                    accounts:[],
                    // 一般纳税人资格认定表
                    file: [
                    ]
                },
                oldFinanceData:{
                },
                //账户
                account:{
                    accountName:'',
                    accountNumber:'',
                    bankName:'',
                    swiftCode:'',
                    province:'',
                    city:''
                },

                // 验证
                rules: {
                    taxpayerRegistrationCode: [
                        { required: true, message: '请输入纳税人识别号', trigger: 'blur' }
                    ],
                    taxpayerType:[
                        {required: true, type:'number', message: '请选择纳税人类型', trigger: 'change' }
                    ]
                },

                bankRules:{
                    accountName: [
                        { required: true, message: '请输入银行开户名', trigger: 'blur' },
                        { max: 50, message: '请输入50字符以内', trigger: 'blur' }
                    ],
                    accountNumber: [
                        { required: true, message: '请输入银行帐号', trigger: 'blur' }
                    ],
                    bankName:[
                        {required: true, message: '请输入银行名称', trigger: 'blur' }
                    ],
                    province: [
                        { required: true, message: '请输入省', trigger: 'blur' }
                    ],
                    city:[
                        {required: true, message: '请输入市', trigger: 'blur' }
                    ]
                }
            };
        },
        methods: {
            auditRecord(reject){//0:通过 1:驳回
                var that = this;
                if(reject == 1){
                    this.$prompt('请输入驳回原因', '审核驳回', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        inputValidator:function(val){return (val==null || val.trim().length<1) ?false:true},
                        inputErrorMessage: '请输入驳回原因'
                    }).then(({ value }) => {
                        $.get({
                            url: '/suppliers/supplier/finance/audit',
                            data: {
                                suppliersId: that.suppliersId,
                                reject:1,
                                content:value
                            },
                            success: function(result) {
                                if (!result.code) {
                                    that.$message({
                                        message: '驳回成功',
                                        type: 'success'
                                    });
                                    //刷新父页面，关闭当前页面
                                    //window.opener.location.reload();
                                    window.close();
                                } else {
                                    that.showErrorMsg(result.msg, '审核失败，请联系管理员');
                                }
                            }
                        })
                    }).catch(() => {
                        that.$message({
                            type: 'info',
                            message: '已取消审核'
                        });
                    });
                }else{  //审核通过
                    this.$prompt('请输入审核备注', '审核备注', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                    }).then(({ value }) => {
                        $.get({
                            url: '/suppliers/supplier/finance/audit',
                            data: {
                                suppliersId: that.suppliersId,
                                reject:0,
                                content:value
                            },
                            success: function(result) {
                                if (!result.code) {
                                    that.$message({
                                        message: '审核成功',
                                        type: 'success'
                                    });
                                    //跳转
                                    setTimeout(function () {
                                        that.$router.push({
                                            path:'/supplier_info?suppliersId=' + that.suppliersId+'&isStep=2'
                                        })
                                    },500);
                                } else {
                                    that.showErrorMsg(result.msg, '审核失败，请联系管理员');
                                }
                            }
                        })
                    }).catch(() => {
                        that.$message({
                            type: 'info',
                            message: '已取消审核'
                        });
                    });
                }
            },
            showErrorMsg(msg,defaultMsg){
                if(msg) {
                    this.$message.error(msg);
                }else{
                    this.$message.error(defaultMsg);
                }
            },
            initControl(suppliersId,recordId){
                var that = this;
                $.get({
                    url: '/suppliers/supplier/control',
                    data: {
                        suppliersId: suppliersId,
                        type:2,
                        recordId:recordId
                    },
                    success: function(result) {
                        if (!result.code) {
                            that.control = result.data;
                        } else {
                            that.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },
            returnPage(){
                var backType = this.$route.query.backType;
                if(this.control.loginType == 1 && backType && backType==1){
                    this.$router.push({
                        path:'/supplier_info?suppliersId='+this.financeData.suppliersId+"&isStep=2"
                    })
                }else {
                   // window.opener.location.reload();
                    window.close();
                }
            },
            initFinanceInfo(suppliersId,recordId){
                var that = this;
                $.get({
                    url: '/suppliers/supplier/finance/auditDetail',
                    data: {
                        recordId:recordId,
                        suppliersId: suppliersId
                    },
                    success: function(result) {
                        if (!result.code) {
                            that.financeData = result.data.financeData;
                            that.oldFinanceData =result.data.oldFinanceData;
                            that.recordId = result.data.recordId;
                        } else {
                            that.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },
            // 预览图片
            previewPic (e) {
                console.log(e)
                this.dialogVisible = true;
                // 获取当前图片地址
                this.dialogImageUrl = e.currentTarget.src;
            },

            // 预览 一般纳税人资格认定表 图片
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleUpload (response) {
                if (!response.code) {
                    this.financeData.file.push({url:response.data});
                    if(this.financeData.file.length > 0) {
                        this.pic_1 = false;
                    } else {
                        this.pic_1 = true;
                    }
                } else {
                    this.$message({
                        showClose: true,
                        message: response.msg,
                        type: 'error'
                    });
                }
            },
            // 删除 上传图片 一般纳税人认定表
            handleRemoveGeneralTaxpayerFile(file, fileList) {
                var _this = this;
                console.log(file, fileList);
                var picFiles = [];
                for (var i = 0; i < fileList.length; i++) {
                    var curPicFile = fileList[i];
                    picFiles.push(curPicFile);
                }
                _this.financeData.file = picFiles;
            },
            beforeUpload (file) {
                const isJPG = (file.type === 'image/jpeg') || (file.type === 'image/png') || (file.type === 'image/gif') || (file.type === 'image/jpg');
                console.log(isJPG)
                const isLt1M = file.size / 1024 / 1024 < 1;
                if (!isJPG) {
                    this.$message.error('上传图片只能是JPG、GIF、PNG等格式的图片格式!');
                    return isJPG;
                }

                if (!isLt1M) {
                    this.$message.error('上传图片大小不能超过 1MB!');
                    return isLt1M;
                }
            },
            // 纳税人类型 变化
            typeChange (value) {
                if (value==2) {
                    this.isList = false;
                } else {
                    this.isList = true;
                }
            },
            addDomain() {
                if (!this.account.accountName ||  this.account.accountName == '') {
                    this.$message.error('请填写银行开户名');
                    return;
                }

                if (!this.account.accountNumber ||  this.account.accountNumber == '') {
                    this.$message.error('请填写银行账号');
                    return;
                }

                if (!this.account.bankName ||  this.account.bankName == '') {
                    this.$message.error('请填写银行名称');
                    return;
                }

                if (this.financeData.registeredCountry != 1) {
                    if (!this.account.swiftCode ||  this.account.swiftCode == '') {
                        this.$message.error('请填写SwiftCode');
                        return;
                    }
                }

                if (this.financeData.registeredCountry == 1) {
                    if (!this.account.province ||  this.account.province == '') {
                        this.$message.error('请填写省');
                        return;
                    }
                }

                if (this.financeData.registeredCountry == 1) {
                    if (!this.account.city ||  this.account.city == '') {
                        this.$message.error('请填写市');
                        return;
                    }
                }
           
                var account = JSON.parse(JSON.stringify(this.account));

                this.financeData.accounts.push(account);
                //清空填写的数据
                this.account.accountName = '';
                this.account.accountNumber = '';
                this.account.bankName = '';
                this.account.province = '';
                this.account.city = '';
                this.bankFormVisible = false;
            },
            removeDomain(index){
                if(this.financeData.accounts[index].id > 0 ){
                    this.$message.error('该元素不可被删除');
                    return;
                }

                this.financeData.accounts.splice(index,1);
            },
            // 图片 转化成 数组
            fileTransToArray(files){
                var fileArray = [];
                if(files) {
                    for(var i=0;i<files.length;i++) {
                        if(files[i].url){
                            fileArray.push(files[i].url);
                        }
                    }
                }
                return fileArray;
            },
            submitForm(type) {
                var _this =this;
                if(type==0){ //暂存
                    var Data = {};
                    Data = JSON.parse(JSON.stringify(this.financeData));
                    $.ajax({
                        url: '/suppliers/supplier/finance/'+type+'/submit?recordId='+_this.recordId,
                        data: JSON.stringify(Data),
                        dataType: "json",
                        contentType: 'application/json;charset=utf-8',
                        type: 'POST',
                        success: function (result) {
                            if (!result.code) {
                                _this.$message({
                                    message: result.msg,
                                    type: 'success'
                                });
                                _this.recordId = result.data.recordId;
                            } else {
                                _this.$message({
                                    showClose: true,
                                    message: result.msg,
                                    type: 'error'
                                });
                            }
                        }
                    })
                }else{ //提交
                    //驳回后提交
                    if(_this.control.status == 4){
                        _this.submitAudit(type,'');
                    }else{
                        this.$prompt('请输入修改原因', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            inputValidator:function(val){return (val==null || val.trim().length<1) ?false:true},
                            inputErrorMessage: '请输入修改原因'
                        }).then(({ value }) => {
                            _this.submitAudit(type,value);
                        }).catch(() => {
                            this.$message({
                                type: 'info',
                                message: '取消提交'
                            });
                        });
                    }
                }
            },
            submitAudit(type,value){
                var _this = this;
                _this.$refs['financeData'].validate((valid) => {
                    if (valid) {
                        console.log('submit!');
                        var Data = {};
                        Data = JSON.parse(JSON.stringify(this.financeData));
                        if(Data.taxpayerType == 1){
                            if (_this.financeData.file.length>0){
                                Data.generalTaxpayerFiles = _this.fileTransToArray(_this.financeData.file);
                            } else {
                                _this.$message.error('请上传一般纳税人资格认定表');
                                return;
                            }
                        }
                        $.ajax({
                            url: '/suppliers/supplier/finance/'+type+'/submit?remark='+value+'&recordId='+_this.recordId,
                            data: JSON.stringify(Data),
                            dataType: "json",
                            contentType: 'application/json;charset=utf-8',
                            type: 'POST',
                            success: function (result) {
                                if (!result.code) {
                                    _this.recordId = result.data.recordId;
                                    _this.suppliersId = result.data.suppliersId;
                                    _this.$message({
                                        message: result.msg,
                                        type: 'success'
                                    });
                                    // 后台成功 改变路由
                                    if(type == 1){//提交
                                        setTimeout(function () {
                                            _this.$router.push({
                                                path:'./supplier_info?isStep=2&suppliersId=' + _this.suppliersId
                                            })
                                        },500);
                                    }
                                } else {
                                    _this.$message({
                                        showClose: true,
                                        message: result.msg,
                                        type: 'error'
                                    });
                                }
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            }
        },
        mounted () {
            var suppliersId=this.$route.query.suppliersId;
            var recordId=this.$route.query.recordId;
            this.suppliersId = suppliersId;
            this.recordId = recordId;
            this.initControl(suppliersId,recordId);
            this.initFinanceInfo(suppliersId,recordId);
        },
    }
</script>

<style type="text/css" lang="less" scoped>
    .audit_edit_pf {
        padding-left: 60px;
        padding-right: 60px;
    }

    .line {
        margin-left: 3%;
        display: inline-block;
        width: 91%;
        height: 1px;
        border-bottom: 1px dashed #999;
        vertical-align: middle;
    }
    .second_line {
        margin-left: 3%;
        display: inline-block;
        width: 88%;
        height: 1px;
        border-bottom: 1px dashed #666;
        vertical-align: middle;
    }
    .pic_tip {
        font-size: 12px;
        color: #ff4949;
        line-height: 1px;
        padding-top: 4px;
        position: absolute;
        top: 100%;
        left: 0;
    }
    .pic_skan {
        width: 150px;
        height: 150px;
        margin-top: 5px;
        border: 1px solid #c0ccda;
        border-radius: 6px;
        box-sizing: border-box;
        cursor: pointer;
    }
    .pic_skan_red {
        width: 150px;
        height: 150px;
        margin-top: 5px;
        border: 2px solid #ff4a7d;
        border-radius: 6px;
        box-sizing: border-box;
        cursor: pointer;
    }
    .rule_star178 {
        position: relative;
        left:-178px;
    }
    .rule_star100 {
        position: relative;
        left:-100px;
        top: -36px;
    }
</style>


// WEBPACK FOOTER //
// financeInfo.vue?7b76a3cc